import { defineLocaleResourceBundle } from "sanity";
/**
* The locale namespace for the vision tool
*
* @internal
*/
const visionLocaleNamespace = "vision", visionUsEnglishLocaleBundle = defineLocaleResourceBundle({
	locale: "en-US",
	namespace: visionLocaleNamespace,
	resources: () => import("./resources-CIlR0qy4.js")
});
export { visionUsEnglishLocaleBundle as n, visionLocaleNamespace as t };

//# sourceMappingURL=i18n-t8J2mRUI.js.map